function HubReportSkeleton() {
  return <div className="hub-report-cart"></div>;
}

export default HubReportSkeleton;
